import styled from 'styled-components';
import { Button } from '@finect/tabular-core/Button';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { NewSectionInner } from '../../';

export const InsideNavigationContainer = styled.div`
  position: fixed;
  z-index: 3;
  top: 60px;
  left: 0;
  right: 0;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  background-color: #fff;
  backface-visibility: hidden;
  transform: translateY(${({ reveal, theme }) => (reveal ? theme.navHeight - 60 : -60 + theme.collapsedNavHeight)}px);
  transition: transform 0.25s cubic-bezier(0.49, 0.42, 0.52, 0.98);

  ${maxMediaQueries.phone`
    transform: translateY(${({ reveal, theme }) =>
    (reveal ? theme.mobileNavHeight - 60 : -60 + theme.collapsedNavHeight)}px);
  `};

  &:after {
    position: absolute;
    top: -140px;
    left: 0;
    right: 0;
    height: 140px;
    content: '';
    background-color: #fff;
  }
`;

/* eslint-disable */
export const InsideNavigationInner = styled(NewSectionInner)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0;
  padding-bottom: 0;
  font-weight: 500;
  ${fontSmoothing}

  nav {
    display: flex;
    align-items: center;
  }

  ${maxMediaQueries.tablet`
    ${/* sc-sel */ Button} {
      display: none;
    }
  `};
`;
/* eslint-enable */
